import { render, staticRenderFns } from "./rightBanner.vue?vue&type=template&id=07b59b67&"
import script from "./rightBanner.vue?vue&type=script&lang=js&"
export * from "./rightBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports